import React, { createContext, useContext } from 'react';
import {
  GetUnacceptedBatchesResponse,
  SummarizeMinimizedResponse,
} from '@/dashboard/services/dashboardApi';
import DashboardCalculator from '@/dashboard/utils/DashboardCalculations/DashboardCalculator';
import { DashboardRowPeriodDetails } from '@/dashboard/utils/DashboardCalculations/dashboardCalculations.utils';

interface DashboardCountsContextType {
  counts: SummarizeMinimizedResponse;
  unacceptedBatches: GetUnacceptedBatchesResponse;
  bandDetails: DashboardRowPeriodDetails;
  contributionCountByPeriod: Record<string, number>;
}

const DashboardCountsContext = createContext<DashboardCountsContextType | undefined>(undefined);

function DashboardCountsProvider({
  counts,
  unacceptedBatches,
  contributionCountByPeriod,
  children,
}: {
  counts: SummarizeMinimizedResponse;
  unacceptedBatches: GetUnacceptedBatchesResponse;
  children: React.ReactNode;
  contributionCountByPeriod: DashboardCountsContextType['contributionCountByPeriod'];
}) {
  const calculator = new DashboardCalculator(counts, unacceptedBatches);

  return (
    <DashboardCountsContext.Provider
      value={{
        counts,
        unacceptedBatches,
        contributionCountByPeriod,
        bandDetails: calculator.getCalculations(),
      }}
    >
      {children}
    </DashboardCountsContext.Provider>
  );
}

function useDashboardCountsContext() {
  const context = useContext(DashboardCountsContext);

  if (context === undefined) {
    throw new Error('Incorrect use of Context');
  }

  return context;
}

export { DashboardCountsProvider, useDashboardCountsContext };
